import { ListProvider } from './list-provider.model';

export class PrescriberMatchVerification {
  id?: number;
  npi: string;
  matches: boolean;
  frozen: boolean;
  relatedProvider: ListProvider;
}
